import React from 'react';
import { ScoreCardMetric } from '../types/stockAdvice';

interface RiskCardProps {
  riskFactors: ScoreCardMetric[];
  warnings: string[];
  verificationNotes: string[];
}

export const RiskCard: React.FC<RiskCardProps> = ({ riskFactors, warnings, verificationNotes }) => (
  <section className="rounded-3xl border border-amber-400/20 bg-[#1a1413] p-4 space-y-3">
    <h4 className="text-sm font-semibold text-white">Risk Radar</h4>
    <ul className="text-xs text-slate-300 space-y-1">
      {riskFactors.map((risk) => <li key={risk.label} className="break-words">• {risk.label}: {risk.reason}</li>)}
    </ul>
    {warnings.length ? <div className="flex flex-wrap gap-2">{warnings.map((warning, idx) => <span key={`${warning}-${idx}`} className="text-[11px] px-2 py-1 rounded-full bg-amber-500/15 text-amber-200 border border-amber-500/30 break-words">{warning}</span>)}</div> : null}
    {verificationNotes.length ? <ul className="text-[11px] text-slate-400 space-y-1">{verificationNotes.map((note, idx) => <li key={`${note}-${idx}`}>• {note}</li>)}</ul> : null}
  </section>
);
